import React, {Component} from "react";
import PropTypes from "prop-types";
import {Card} from "react-bootstrap";
import "../Elements/FromGroup/form_select.css"
import AscModal from "../Elements/Modal/Modal";
import {ViewPermissionName, ViewPermissionDetail} from "../Elements/AscElements/PermissionElements";


export default class PermissionReadModal extends Component {

    render() {
        return (
            <AscModal
                state={this.props.state}
                propSetState={this.props.propSetState}
                langText={this.props.langText}
                validationHandle={this.props.validationHandle}
                onClick={this.props.onClick}>
                <Card variant="info">
                    <Card.Header>
                        <Card.Title>
                            {this.props.langText.Body.PermissionInfo}
                        </Card.Title>
                    </Card.Header>

                    <Card.Body>
                        <ViewPermissionName
                            state={this.props.state}
                            langText={this.props.langText}>
                        </ViewPermissionName>
                        <ViewPermissionDetail
                            state={this.props.state}
                            langText={this.props.langText}
                            boardWidth={this.props.boardWidth}
                            userInfo={this.props.userInfo}>
                        </ViewPermissionDetail>
                    </Card.Body>
                </Card>
            </AscModal>
        );
    }
}

PermissionReadModal.propTypes = {
    state: PropTypes.object.isRequired,
    langText: PropTypes.object.isRequired,
    boardWidth: PropTypes.object.isRequired,
    userInfo: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
    validationHandle: PropTypes.func.isRequired,
    propSetState: PropTypes.func,
};
